import React, { useState, useEffect, useRef } from 'react';
import RenderProfilePic from '../../../extras/RenderProfilePic';
import {
  getAllRoundsForJobGroup,
  getStudents,
  AddStudentsToJobGroup,
  getJobGroupById,
  updateStatusOfJobGroupById,
  bulkUpdateRoundStatus,
} from '../../../services/apiService';
import moment from 'moment';
import { Icon, Button } from 'semantic-ui-react';
import { Menu, MenuItem } from '@material-ui/core';
import {
  MoreVert,
  Lock,
  UpdateRounded,
  CalendarViewDayRounded,
} from '@material-ui/icons';
import { ExpandableTable } from '../job-groups/_components/ExpandableTable/Table';
import { getFullName } from '../../../utils';
import { UpdateJobRoleInfo } from '../job-groups/_components/UpdateJobRoleInfo';
import { Student } from '../_components/Student';
import { useLocation, useHistory } from 'react-router-dom';
import XLSX from 'xlsx';
import 'react-datepicker/dist/react-datepicker.css';
import '../job-groups/_components/style.css';
import BulkUpdateRoundStatusModal from '../job-groups/_components/Modals/BulkUpdateRoundStatusModal';
import BulkInterviewScheduleUpdateModal from '../job-groups/_components/Modals/BulkInterviewScheduleUpdateModal';
import BulkAddStudentsFromCSVModal from '../job-groups/_components/Modals/BulkAddStudentsFromCSVModal';

const bulkUpdateStatusOptions = [
  {
    key: 'cleared',
    text: 'cleared',
    value: 'cleared',
  },
  {
    key: 'not cleared',
    text: 'not cleared',
    value: 'not cleared',
  },
  {
    key: 'scheduled',
    text: 'scheduled',
    value: 'scheduled',
  },
  {
    key: 'unscheduled',
    text: 'unscheduled',
    value: 'unscheduled',
  },
  {
    key: 'paused',
    text: 'paused',
    value: 'paused',
  },
  {
    key: 'decision awaiting',
    text: 'decision awaiting',
    value: 'decision awaiting',
  },
];

const UpdateJobGroup = (props) => {
  const location = useLocation();
  const history = useHistory();
  const bulkInterviewSchedulesApplyTimeBtnRef = useRef(null);
  const [isBulkUpdateModalOpen, setIsBulkUpdateModalOpen] = useState(false);
  const [bulkRoundStatus, setBulkRoundStatus] = useState('cleared');
  const [selectedJobApplications, setSelectedJobApplications] = useState([]);
  const [selectedJobApplicationsData, setSelectedJobApplicationsData] =
    useState([]);
  const [showUpdateRoleInfo, setShowUpdateRoleInfo] = useState(false);
  const [showAddStudentsForm, setShowAddStudentsForm] = useState(false);
  const [jobApplications, setJobApplications] = useState([]);
  const [filteredJobApplications, setFilteredJobApplications] = useState([]);
  const [remainingStudents, setRemainingStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [showBulkAddStudentFromCSVModal, setShowBulkAddStudentFromCSVModal] =
    useState(false);
  const [jobGroupActionOptions, setJobGroupActionOptions] = useState([
    {
      key: 'closed',
      text: 'Close group',
      value: 'closed',
    },
    {
      key: 'upload',
      text: 'Upload students',
      value: 'upload',
    },
  ]);
  const [
    assignmentTypeForBulkUpdateFilterIsActive,
    setAssignmentTypeForBulkUpdateFilterIsActive,
  ] = useState(false);
  const [
    manualControlForBulkUpdateFilterIsActive,
    setManualControlForBulkUpdateFilterIsActive,
  ] = useState(false);
  const [jobGroupDetails, setJobGroupDetails] = useState(null);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [anchor, setAnchor] = useState(null);
  const [bulkImportedStudents, setBulkImportedStudents] = useState([]);
  const [isCSVPreviewModalVisible, setIsCSVPreviewModalVisible] =
    useState(false);
  const [
    isBulkInterviewScheduleModalOpen,
    setIsBulkInterviewScheduleModalOpen,
  ] = useState(false);
  const [
    startDateForBulkInterviewSchedule,
    setStartDateForBulkInterviewSchedule,
  ] = useState(new Date());
  const [viewBulkImportedStudentsData, setViewBulkImportedStudentsData] =
    useState([]);
  const [spreadsheetFile, setSpreadSheetFile] = useState(null);
  const spreadsheetFileRef = useRef(null);

  const getSelectedJobApplications = (
    selectedCandidates,
    selectedCandidatesData
  ) => {
    setSelectedJobApplications(selectedCandidates);
    selectedCandidatesData = selectedCandidatesData.map((_candidate, i) => {
      // just map though the candidate and add a new key schedule to the data of each row
      // and set the value to the current date
      _candidate = _candidate.map((row) => {
        row.data.schedule =
          row.data.startTime || row.data.deadline || new Date();
        return row;
      });

      return _candidate;
    });
    setSelectedJobApplicationsData(selectedCandidatesData);
  };

  const handleStudentSpreadSheetUpload = async (e) => {
    e.preventDefault();
    const _file = e.target.files;
    if (_file.length !== 0) {
      handleFile(_file[0]);
    }
  };
  const handleFile = (file) => {
    const reader = new FileReader();
    const readAsBinary = !!reader.readAsBinaryString;
    reader.onload = (e) => {
      const binaryString = e.target.result;
      const readStream = XLSX.read(binaryString, {
        type: readAsBinary ? 'binary' : 'array',
        cellDates: true,
        dateNF: 'mm/dd/yyyy',
      });
      // Get first worksheet
      const sheetName = readStream.SheetNames[0];
      const _sheet = readStream.Sheets[sheetName];
      // Convert array of arrays
      const sheetData = XLSX.utils.sheet_to_json(_sheet, { header: 1 });
      const studentData = sheetData ?? [];
      studentData.shift(); // returns the headers
      setViewBulkImportedStudentsData(
        studentData.map((student) => {
          return {
            name: student[2],
            email: student[3],
            phone: student[4],
          };
        }) ?? []
      );
      setBulkImportedStudents(
        studentData.map((student) => {
          return student[3];
        }) ?? []
      );
    };
    if (readAsBinary) reader.readAsBinaryString(file);
    else reader.readAsArrayBuffer(file);
  };

  const updateJobGroupStatus = async (groupStatus) => {
    try {
      await updateStatusOfJobGroupById({
        groupId: jobGroupDetails?.groupId,
        status: groupStatus,
      });
      // fetch job group details again
      await getJobDetailsById(jobGroupDetails.groupId);
    } catch (error) {
      console.log('error in updating status::', error);
    }
  };

  const handleActionChange = async (action) => {
    try {
      if (action.value === 'closed') {
        await updateJobGroupStatus('closed');
      }
      if (action.value === 'open') {
        await updateJobGroupStatus('open');
      }
      if (action.value === 'upload') {
        setShowBulkAddStudentFromCSVModal(true);
        setAnchor(null);
      }
    } catch (error) {
      console.log('error in closing jobgroup::', error);
    }
  };

  const addStudent = (studentId) => {
    setSelectedStudents([...selectedStudents, studentId]);
  };

  const removeStudent = (studentId) => {
    setSelectedStudents(selectedStudents.filter((id) => id !== studentId));
  };

  // add or remove students from selected students array
  const handleSelect = (isSelected, studentId) => {
    if (isSelected) {
      addStudent(studentId);
    } else {
      removeStudent(studentId);
    }
  };

  const toggleShowAddStudentsForm = () => {
    setShowAddStudentsForm(!showAddStudentsForm);
  };

  const toggleUpdateRoleInfo = () => {
    setShowUpdateRoleInfo(!showUpdateRoleInfo);
  };

  // bulk update status of selected job applications
  const bulkUpdateStatus = async (status) => {
    try {
      await bulkUpdateRoundStatus({
        jobApplicationIdLists: selectedJobApplications,
        roundStatus: bulkRoundStatus,
      });
      // fetch job group details again
      await getJobDetailsById(jobGroupDetails.groupId);
      // fetch job applications again
      await fetchJobApplicationsForJobGroup(jobGroupDetails.groupId);

      setIsBulkUpdateModalOpen(false);
    } catch (error) {
      console.log('error in bulk update status::', error);
    }
  };

  const addStudentsToJobGroupById = React.useCallback(async () => {
    try {
      // setLoading(true);
      if (jobGroupDetails) {
        await AddStudentsToJobGroup({
          groupId: jobGroupDetails?.groupId,
          students: selectedStudents,
        });
        fetchJobApplicationsForJobGroup(jobGroupDetails?.groupId);
        fetchStudents();
        await getJobDetailsById(jobGroupDetails?.groupId);
      }
      // setLoading(false);
    } catch (error) {
      console.log(error);
      // setLoading(false);
    }
  }, [jobGroupDetails, selectedStudents]);

  const addBulkStudentsFromCSVToJobGroupById = React.useCallback(async () => {
    try {
      // setLoading(true);
      if (jobGroupDetails) {
        await AddStudentsToJobGroup({
          groupId: jobGroupDetails?.groupId,
          studentArrayType: 'email',
          students: bulkImportedStudents,
        });
        fetchJobApplicationsForJobGroup(jobGroupDetails?.groupId);
        fetchStudents();
        setShowBulkAddStudentFromCSVModal(false);
        await getJobDetailsById(jobGroupDetails?.groupId);
      }
      // setLoading(false);
    } catch (error) {
      console.log(error);
      // setLoading(false);
    }
  }, [jobGroupDetails, bulkImportedStudents]);

  const fetchStudents = React.useCallback(async () => {
    try {
      const response = await getStudents();
      const allStudents = response?.data;
      const addedStudents = jobGroupDetails?.students;
      const _filteredStudents = allStudents.filter((student) => {
        const userDetails = student?.userDetails;
        // filter out students who are already added to the job group by id
        return !addedStudents.some((addedStudent) => {
          return addedStudent.id === userDetails.id;
        });
      });

      setRemainingStudents(_filteredStudents);
    } catch (error) {
      console.log(error);
    }
  }, [jobGroupDetails]);

  const fetchJobApplicationsForJobGroup = async (
    jobGroupId,
    sortType = 'progressLevel'
  ) => {
    try {
      // setLoading(true);
      const response = await getAllRoundsForJobGroup({
        groupId: jobGroupId,
        sortType,
      });
      // setLoading(false);
      setJobApplications(response.data);
    } catch (error) {
      // setLoading(false);
      console.log(error);
    }
  };
  const getJobDetailsById = async (jobGroupId) => {
    try {
      // setLoading(true);
      const response = await getJobGroupById({ groupId: jobGroupId });
      // setLoading(false);
      setJobGroupDetails(response.data);
    } catch (error) {
      // setLoading(false);
      console.log(error);
    }
  };

  const offerMadeOnChangeHandler = (data) => {
    if (jobGroupDetails) {
      fetchJobApplicationsForJobGroup(jobGroupDetails?.groupId);
      fetchStudents();
    }
  };

  useEffect(() => {
    // if search query is present and showAddStudentsForm is true
    // then filter out students based on search query otherwise show all students
    if (searchQuery && showAddStudentsForm) {
      const _filteredStudents = remainingStudents.filter((student) => {
        const studentName = getFullName(student?.userDetails);
        return studentName.toLowerCase().includes(searchQuery.toLowerCase());
      });
      setFilteredStudents(_filteredStudents);
    } else {
      setFilteredStudents(remainingStudents);
    }
    // if search query is present and showAddStudentsForm is false
    // then filter out job applications based on search query otherwise show all job applications
    if (searchQuery && !showAddStudentsForm) {
      const filteredJobApplications = jobApplications.filter(
        (jobApplication) => {
          const studentName = getFullName(jobApplication?.userDetails);
          return studentName.toLowerCase().includes(searchQuery.toLowerCase());
        }
      );
      setFilteredJobApplications(filteredJobApplications);
    } else {
      setFilteredJobApplications(jobApplications);
    }
  }, [searchQuery, jobApplications, remainingStudents, showAddStudentsForm]);

  useEffect(() => {
    const _jobGroupId = location?.pathname?.split('/')[3];
    if (_jobGroupId) {
      getJobDetailsById(_jobGroupId);
    }
  }, [location]);

  useEffect(() => {
    if (jobGroupDetails) {
      if (jobGroupDetails?.status === 'closed') {
        setJobGroupActionOptions([
          {
            key: 'open',
            text: 'Open group',
            value: 'open',
          },
          {
            key: 'upload',
            text: 'Upload students',
            value: 'upload',
          },
        ]);
      } else {
        setJobGroupActionOptions([
          {
            key: 'closed',
            text: 'Close group',
            value: 'closed',
          },
          {
            key: 'upload',
            text: 'Upload students',
            value: 'upload',
          },
        ]);
      }
      fetchJobApplicationsForJobGroup(jobGroupDetails?.groupId);
      fetchStudents();
    }
  }, [jobGroupDetails]);

  useEffect(() => {
    if (!manualControlForBulkUpdateFilterIsActive) {
      // set schedule in selectedJobApplicationsData
      setSelectedJobApplicationsData(
        selectedJobApplicationsData.map((application) => {
          application = application.map((round) => {
            round.data.schedule = startDateForBulkInterviewSchedule;
            return round;
          });
          // return the candidate with the currentRoundNumber changed to the roundNumber of the _assignmentRound
          return application;
        })
      );
    }
  }, [manualControlForBulkUpdateFilterIsActive]);

  return (
    <div className='grid grid-cols-12 gap-4'>
      {!showUpdateRoleInfo ? (
        <div className='col-span-12 '>
          {/* Update JobGroup header start */}
          <div className='flex-col items-center justify-between px-5 py-3 bg-white rounded shadow-md'>
            <div className='flex items-center justify-between '>
              <div className='flex'>
                <RenderProfilePic
                  thumbnail={jobGroupDetails?.companyDetails?.companyAvatar}
                  name={jobGroupDetails?.companyDetails?.companyName}
                  size={4}
                />
                <div className='flex-col ml-4'>
                  <div className='font-bold text-font-black'>
                    {jobGroupDetails?.companyDetails?.companyName}
                  </div>
                  <div className='text-sm text-font-dark'>
                    {jobGroupDetails?.jobTitleDetails?.title}
                  </div>
                  <div className='text-font-dark'>
                    <div className='relative flex items-center text-xs '>
                      {moment(jobGroupDetails?.createdAt)
                        .utc()
                        .format('DD/MM/YYYY')}
                      <span className='ml-2 text-xs text-gray-400'>
                        ({moment(jobGroupDetails?.createdAt).utc().fromNow()})
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className='flex ml-4 text-xs text-right'>
                <button
                  onClick={() => {
                    toggleShowAddStudentsForm();
                  }}
                  disabled={jobGroupDetails?.status === 'closed'}
                  className={` ${
                    jobGroupDetails?.status === 'closed'
                      ? 'bg-brand-secondary text-white cursor-not-allowed'
                      : ' bg-pastel-red '
                  } text-base font-medium ${
                    jobGroupDetails?.status === 'closed'
                      ? 'text-white'
                      : ' text-brand-primary '
                  } px-8 py-2 ml-5 rounded`}
                >
                  <Icon name='add' />
                  <span> Add students </span>
                </button>
                <button
                  onClick={() => {
                    history.push({
                      pathname: `/job-dashboardv2/chat/${jobGroupDetails?.groupId}`,
                    });
                  }}
                  className='px-8 py-2 ml-5 text-base font-medium rounded bg-pastel-red text-brand-primary'
                >
                  <Icon name='add' />
                  <span> Group Chat </span>
                </button>
                <button
                  onClick={() => {
                    toggleUpdateRoleInfo();
                  }}
                  disabled={jobGroupDetails?.status === 'closed'}
                  className={` ${
                    jobGroupDetails?.status === 'closed'
                      ? 'bg-brand-secondary  cursor-not-allowed'
                      : ' bg-pastel-red '
                  } text-base font-medium ${
                    jobGroupDetails?.status === 'closed'
                      ? 'text-white'
                      : ' text-brand-primary '
                  } px-8 py-2 ml-5 rounded`}
                >
                  <Icon name='add' />
                  <span> Update Job Role Info</span>
                </button>

                <Button
                  onClick={(e) => setAnchor(e.currentTarget)}
                  aria-controls='actions-menu'
                  aria-haspopup='true'
                  className='opacity-60'
                >
                  <MoreVert />
                </Button>

                <Menu
                  id='simple-menu'
                  anchorEl={anchor}
                  open={Boolean(anchor)}
                  onClose={() => setAnchor(null)}
                  keepMounted
                >
                  {jobGroupActionOptions.map((action) => (
                    <MenuItem
                      onClick={() => handleActionChange(action)}
                      value={action.value}
                      key={action.value}
                    >
                      {action.text}
                    </MenuItem>
                  ))}
                </Menu>
              </div>
            </div>
            <hr className='mt-5 mb-8 border-6' />
            <div className='flex ml-4 text-xs text-right'>
              <div
                onClick={() => {}}
                className='px-8 py-2 ml-8 text-base font-medium text-white bg-gray-300 border rounded border-primary-400'
              >
                <div className='flex-col'>
                  <div className='text-xs text-left text-font-para '>Total</div>
                  <span className='flex justify-center text-base font-semibold text-font-para'>
                    {`${jobGroupDetails?.studentsCount} Shortlisted`}
                  </span>
                </div>
              </div>
              {jobGroupDetails?.studentsInRounds &&
                Object.keys(jobGroupDetails?.studentsInRounds).map((round) => {
                  return (
                    <div
                      key={round}
                      onClick={() => {}}
                      className='px-8 py-2 ml-2 text-base font-medium text-white bg-gray-300 border rounded border-primary-400'
                    >
                      <div className='flex-col'>
                        <div className='text-xs text-left capitalize text-font-para'>
                          {round}
                        </div>
                        <span className='flex justify-center text-base font-semibold text-font-para'>
                          {`${jobGroupDetails?.studentsInRounds[round]}   ${
                            jobGroupDetails?.studentsInRounds[round] === 1
                              ? 'Candidate'
                              : 'Candidates'
                          }`}
                        </span>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          {/* Update JobGroup header end */}
          {/* View/Add student header end */}
          <div className='flex items-center justify-between pt-8'>
            <form
              className='flex items-center'
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <label htmlFor='simple-search' className='sr-only'>
                Search by name
              </label>
              <div className='relative w-full'>
                <div className='absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none'>
                  <svg
                    aria-hidden='true'
                    className='w-5 h-5 text-gray-500 dark:text-gray-400'
                    fill='currentColor'
                    viewBox='0 0 20 20'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      fillRule='evenodd'
                      d='M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z'
                      clipRule='evenodd'
                    />
                  </svg>
                </div>
                <input
                  type='text'
                  id='simple-search'
                  className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                  placeholder='Search by name'
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </form>

            {/* Icons for filter and sort */}
            <div className='flex items-center  '>
              {/* candidate count */}
              {selectedJobApplications.length > 1 && (
                <div className='flex items-center'>
                  <span className='text-base  font-bold  text-gray-500 dark:text-gray-700'>
                    {selectedJobApplications.length}{' '}
                    {selectedJobApplications.length === 1
                      ? 'Candidate'
                      : 'Candidates'}
                  </span>
                </div>
              )}
              {selectedJobApplications.length > 1 && (
                <div
                  className='flex items-center bg-green-c3 rounded shadow-md ml-5 mr-5'
                  onClick={() => setIsBulkInterviewScheduleModalOpen(true)}
                >
                  <Button
                    aria-controls='actions-menu'
                    aria-haspopup='true'
                    className='opacity-60'
                    // onClick={() => setIsBulkInterviewScheduleModalOpen(true)}
                  >
                    <CalendarViewDayRounded />
                  </Button>
                  <p className='text-sm text-gray-500 dark:text-white mr-5 uppercase cursor-pointer'>
                    Update schedule
                  </p>
                </div>
              )}
              {selectedJobApplications.length > 1 && (
                <div
                  className='flex items-center bg-blue-c4 rounded shadow-md'
                  onClick={() => setIsBulkUpdateModalOpen(true)}
                >
                  <Button
                    aria-controls='actions-menu'
                    aria-haspopup='true'
                    className='opacity-60'
                    // onClick={() => setIsBulkUpdateModalOpen(true)}
                  >
                    <UpdateRounded />
                  </Button>
                  <p className='text-sm text-gray-500 dark:text-white mr-5 uppercase cursor-pointer'>
                    Update status
                  </p>
                </div>
              )}
            </div>
          </div>
          <div className='relative'>
            {/* Lock icon for closed job group */}
            {jobGroupDetails?.status === 'closed' && (
              <div
                className='absolute top-0 left-0 flex items-center justify-center w-full h-full bg-white bg-opacity-50'
                style={{ zIndex: '1111', filter: 'none !important' }}
              >
                <div className='flex flex-col items-center justify-center'>
                  <Lock size={40} />
                  <p className='text-base font-extrabold text-gray-500 dark:text-gray-400'>
                    This job role is closed . Reopen the group to make changes.
                  </p>
                </div>
              </div>
            )}

            <div
              style={
                jobGroupDetails?.status === 'closed'
                  ? {
                      filter: 'blur(1px)',
                      cursor: 'not-allowed',
                      position: 'relative',
                    }
                  : {}
              }
              onClick={(e) => {
                if (jobGroupDetails?.status === 'closed') {
                  e.preventDefault();
                  e.stopImmediatePropagation();
                }
              }}
            >
              {showAddStudentsForm ? (
                <div>
                  {filteredStudents.map((student, i) => (
                    <Student
                      key={i}
                      student={student}
                      handleSelect={handleSelect}
                    />
                  ))}
                  <div className='flex fixed z-90 bottom-10 inset-x-1/2 w-full '>
                    <button
                      onClick={() => {
                        toggleShowAddStudentsForm();
                      }}
                      className='px-8 py-2 ml-8 text-base font-medium border rounded text-gray border-primary-400 bg-white'
                    >
                      Cancel
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        addStudentsToJobGroupById();
                        toggleShowAddStudentsForm();
                      }}
                      className='px-8 py-2 ml-8 text-base font-medium text-white border rounded bg-brand-primary border-primary-400'
                    >
                      Add Students
                    </button>
                  </div>
                </div>
              ) : (
                <ExpandableTable
                  data={filteredJobApplications.map((jobApplication) => {
                    return {
                      ...jobApplication,
                      candidate: getFullName(jobApplication?.userDetails),
                      candidateEmail: jobApplication?.userDetails?.email,
                    };
                  })}
                  onChangeHandler={offerMadeOnChangeHandler}
                  getSelectedJobApplications={getSelectedJobApplications}
                />
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className='col-span-12 '>
          <UpdateJobRoleInfo
            toggleUpdateRoleInfo={toggleUpdateRoleInfo}
            jobGroupDetails={jobGroupDetails}
            fetchJobApplicationsForJobGroup={fetchJobApplicationsForJobGroup}
            getJobDetailsById={getJobDetailsById}
          />
        </div>
      )}

      <BulkUpdateRoundStatusModal
        isBulkUpdateModalOpen={isBulkUpdateModalOpen}
        setIsBulkUpdateModalOpen={setIsBulkUpdateModalOpen}
        selectedJobApplications={selectedJobApplications}
        bulkUpdateStatusOptions={bulkUpdateStatusOptions}
        bulkRoundStatus={bulkRoundStatus}
        setBulkRoundStatus={setBulkRoundStatus}
        bulkUpdateStatus={bulkUpdateStatus}
      />
      {/* Start of bulk interview schedule modal */}
      <BulkInterviewScheduleUpdateModal
        setIsBulkInterviewScheduleModalOpen={
          setIsBulkInterviewScheduleModalOpen
        }
        isBulkInterviewScheduleModalOpen={isBulkInterviewScheduleModalOpen}
        selectedJobApplications={selectedJobApplications}
        manualControlForBulkUpdateFilterIsActive={
          manualControlForBulkUpdateFilterIsActive
        }
        setManualControlForBulkUpdateFilterIsActive={
          setManualControlForBulkUpdateFilterIsActive
        }
        startDateForBulkInterviewSchedule={startDateForBulkInterviewSchedule}
        setStartDateForBulkInterviewSchedule={
          setStartDateForBulkInterviewSchedule
        }
        assignmentTypeForBulkUpdateFilterIsActive={
          assignmentTypeForBulkUpdateFilterIsActive
        }
        setAssignmentTypeForBulkUpdateFilterIsActive={
          setAssignmentTypeForBulkUpdateFilterIsActive
        }
        setSelectedJobApplicationsData={setSelectedJobApplicationsData}
        selectedJobApplicationsData={selectedJobApplicationsData}
        bulkInterviewSchedulesApplyTimeBtnRef={
          bulkInterviewSchedulesApplyTimeBtnRef
        }
        jobGroupDetails={jobGroupDetails}
        setSelectedJobApplications={setSelectedJobApplications}
        getJobDetailsById={getJobDetailsById}
        fetchJobApplicationsForJobGroup={fetchJobApplicationsForJobGroup}
      />
      {/* End of bulk interview schedule modal */}
      {/* Start BulkAddStudentFromCSV Modal */}
      <BulkAddStudentsFromCSVModal
        showBulkAddStudentFromCSVModal={showBulkAddStudentFromCSVModal}
        setShowBulkAddStudentFromCSVModal={setShowBulkAddStudentFromCSVModal}
        isCSVPreviewModalVisible={isCSVPreviewModalVisible}
        spreadsheetFileRef={spreadsheetFileRef}
        spreadsheetFile={spreadsheetFile}
        setSpreadSheetFile={setSpreadSheetFile}
        setBulkImportedStudents={setBulkImportedStudents}
        setViewBulkImportedStudentsData={setViewBulkImportedStudentsData}
        bulkImportedStudents={bulkImportedStudents}
        handleStudentSpreadSheetUpload={handleStudentSpreadSheetUpload}
        viewBulkImportedStudentsData={viewBulkImportedStudentsData}
        setIsCSVPreviewModalVisible={setIsCSVPreviewModalVisible}
        addBulkStudentsFromCSVToJobGroupById={
          addBulkStudentsFromCSVToJobGroupById
        }
      />
      {/* End BulkAddStudentFromCSV Modal */}
    </div>
  );
};
export default UpdateJobGroup;
